
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import ToolButton from '../toolbar/ToolButton';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandZoomOut = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        buttonCommandClick(dispatch, 'ZOOM_OUT', null, props.actionType);
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('Remove')}
            styles={{
                root: { color: '#FFFFFF' },
                rootHovered: { color: '#323436' },
            }}
            title="Oddálit"
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomOut;
